import React from "react";
import { Bird } from "lucide-react";
import { isFeatureActive } from "../../../utils/secretCodes";

const GameButton = ({ onClick }) => {
  const isGameUnlocked = isFeatureActive("FLAPPY_TRADE_GAME");

  if (!isGameUnlocked) return null;

  return (
    <button
      onClick={onClick}
      className="game-trigger-button"
      title="Play FlappyTrade"
    >
      <Bird size={20} />
    </button>
  );
};

export default GameButton;
